export default "__VITE_ASSET__f9KcZV67__"